<template>
    <div class="searchMachine__appliedFacets appliedFacetsList">
        <p class="appliedFacetsList__heading">
            Filters:
            <span
                v-if="!appliedFacets.length"
                class="appliedFacetsList__empty"
            >
                None selected
            </span>
        </p>
        <ul
            v-if="appliedFacets.length"
            class="appliedFacetsList__list"
        >
            <li
                class="appliedFacetsList__item"
                v-for="(facet, index) in appliedFacets"
                :key="`${facet.type}_${index}`"
            >
                <div class="pill -blue">
                    {{ facet.label }}
                    <div
                        class="pill__dismiss"
                        @click="removeFacet(facet)"
                    >
                        <i class="fas fa-times-circle" />
                    </div>
                    <!-- /.pill__dismiss -->
                </div>
                <!-- /.pill -->
            </li>
            <li class="appliedFacetsList__item">
                <div class="pill">
                    Clear filters
                    <div
                        class="pill__dismiss"
                        @click="clearFacets"
                    >
                        <i class="fas fa-times-circle" />
                    </div>
                    <!-- /.pill__dismiss -->
                </div>
                <!-- /.pill -->
            </li>
        </ul>
    </div>
    <!-- /.searchMachine__appliedFacets -->
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    computed: {
        ...mapState('search', ['appliedFacets']),
    },
    methods: {
        ...mapActions('search', ['removeFacet', 'clearFacets']),
    },
};
</script>
